import React from 'react';
import PropTypes from 'prop-types';

function CloseIcon(props) {
  const { color = 'currentColor', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...rest}
    >
      <defs>
        <path
          id="close"
          d="M11.19.275l1.414 1.414-4.501 4.5 4.5 4.5-1.414 1.415-4.5-4.501-4.5 4.5L.775 10.69l4.5-4.5-4.5-4.5L2.19.275l4.5 4.5z"
        />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(5 6)">
        <mask id="close-mask" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill={color} fillRule="nonzero" xlinkHref="#close" />
        <g fill={color} mask="url(#close-mask)">
          <path d="M-5-6h24v24H-5z" />
        </g>
      </g>
    </svg>
  );
}

CloseIcon.propTypes = {
  color: PropTypes.string,
};

export default React.memo(CloseIcon);
